import Telegram from '@mui/icons-material/Telegram';
import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { signIn } from 'utils/auth';

export const LoginButton: FC = () => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      size="large"
      startIcon={<Telegram />}
      onClick={signIn}
      sx={{
        borderRadius: '4px',
        backgroundColor: '#2aabee',
        '&:hover': { backgroundColor: '#229ed9' },
      }}
    >
      {t('common.login_with_telegram')}
    </Button>
  );
};
